<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Checkout' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<div class="container-fluid py-5">
  <div class="row">
    <div class="col-12 mb-2">
        <p class="deliveryMethodTitle mb-3 text-center">Delivery option</p>
        <div class="row mx-3 py-3 delivery-option-container">
            <!-- <div class="col-lg-6 col-md-6 text-center">
                <img class="m-auto" src="../../../../assets/img/home2/deliveryMethod.png" width="90%" alt="Cart">
            </div> -->
            <div class="col-lg-12 col-md-12 text-center m-auto">
                <div class="mt-3 deliveryMethodContainer">

                    <div class="payment-option d-flex align-items-center" style="border-radius: 5px 0 0 5px; ">
                        <input type="radio" id="delivery" name="deliveryMethod" checked [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('delivery')" value="delivery">
                        <label style="font-size: 18px;padding: 15px 40px;" for="delivery">
                            <!-- <img src="../../../../assets/img/home2/delivery-bike.png" alt=""> -->
                            <p>Delivery</p>
                        </label>
                    </div>
                    <div class="payment-option d-flex align-items-center" style="border-radius: 0 5px 5px 0; ">
                        <input type="radio" id="pickup" name="deliveryMethod" [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('pickup')" value="pickup">
                        <label style="font-size: 18px;padding: 15px 40px;" for="pickup">
                            <!-- <img src="../../../../assets/img/home2/pickup.png" alt=""> -->
                            <p>Pickup</p>
                        </label>
                    </div>
                    
                </div>
                <div>
                    <small *ngIf="deliveyOption == 'pickup'" class="text-success" style="font-size: 14px !important;">Please notice your mailbox to get your order details</small>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mb-2">
        <div *ngIf="!isLoading && cartItemsLength != 0 " style="padding: 10px;">
            <div class="row">
                <div *ngFor="let item of cartItems;let i = index;" class="position-relative pb-1 col-lg-4 col-md-6" >
                    <div style="box-shadow: 1px 1px 10px 3px rgba(0, 0, 0, 0.1);position: relative;height: 100%;padding: 10px;">
                        <a class="delete-btn" (click)="removeItem(i)" style="position: absolute;right: 7px;"><i class="bx bx-trash" style="font-size: 20px;"></i></a>
                        <div class="text-center p-1">
                            <img [src]="item.avatar" [alt]="item.name" width="120" height="120" style="border-radius: 20px;" class="" alt="Product">
                            <div class="ps-2 w-100">
                                <h6 class="mb-1">{{item.name}}</h6>
                                <p class="text-muted mb-1">{{item.components}}</p>
                                
                                <!-- Display Selected Extras -->
                                <div *ngIf="item.selectedExtraId && item.selectedExtraId.length > 0">
                                    <p class="description mb-0">Extras: 
                                        <span class="mt-0" *ngFor="let extra of item.selectedExtraId; let last = last" style="color: #c71d1d;">
                                            {{ extra.name }}<span *ngIf="extra.quantity > 1"> ({{ extra.quantity }}x)</span><span *ngIf="!last">, </span>
                                        </span>
                                    </p>
                                </div>
                                
                                <!-- Display Free Sides -->
                                <div *ngIf="item.selectedFreeSides && item.selectedFreeSides.length > 0">
                                    <p class="description mb-0">Free Sides: 
                                        <span class="mt-0" *ngFor="let side of item.selectedFreeSides; let last = last" style="color: #c71d1d;">
                                            {{ side.name }}<span *ngIf="!last">, </span>
                                        </span>
                                    </p>
                                </div>
                                
                                <div class="d-flex align-items-center" style="float: left;">
                                    <span class="text-muted" *ngIf="item.offer" style="text-decoration: line-through; margin-right: 5px;">
                                        ${{getOriginalItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span class="text-muted" [class.text-danger]="item.offer">
                                        ${{getItemPrice(item) | number:'1.2-2'}}
                                    </span>
                                    <span *ngIf="item.offer" class="badge bg-danger ms-2" style="font-size: 10px;">
                                        {{getOfferText(item)}}
                                    </span>
                                    
                                    <!-- Show item total (unit price * quantity) -->
                                    <span class="text-muted ms-2" style="font-size: 0.9em;">
                                        × {{item.quantity}} = ${{getItemTotalPrice(item) | number:'1.2-2'}}
                                    </span>
                                </div>
                                <span class="text-muted float-end">QTY: {{item.quantity}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isLoading && cartCustomProducts.length != 0" style="padding: 10px;">
            <h4 class="mb-3">Custom Products</h4>
            <div class="row">
                <div *ngFor="let customItem of cartCustomProducts;let i = index;" class="position-relative pb-1 col-lg-4 col-md-6">
                    <div style="box-shadow: 1px 1px 10px 3px rgba(0, 0, 0, 0.1);position: relative;height: 100%;padding: 10px;">
                        <a class="delete-btn" (click)="removeCustomItem(i)" style="position: absolute;right: 7px;cursor: pointer;">
                            <i class="bx bx-trash" style="font-size: 20px;"></i>
                        </a>
                        <div class="text-center p-1">
                            <img [src]="getCustomProductImage(customItem)" [alt]="getCustomProductName(customItem)" width="80" height="80" style="border-radius: 20px;" class="" alt="Product">
                            <div class="ps-2 w-100">
                                <h6 class="mb-1">{{getCustomProductName(customItem)}}</h6>
                                
                                <p class="small text-muted mb-1" *ngIf="getCustomProductSize(customItem)">
                                    Size: {{getCustomProductSize(customItem)}}
                                </p>

                                <p class="small text-muted mb-1" *ngIf="isHalfAndHalf(customItem)">
                                    <span style="color: #c71d1d; font-weight: bold;">Half & Half</span>
                                </p>

                                <div class="ingredients-section mt-1" *ngIf="!isHalfAndHalf(customItem)">
                                    <p class="small text-muted mb-1">
                                        <span style="color: #333;">Ingredients: </span>
                                        <span *ngFor="let ingredient of getAllIngredients(customItem); let last = last" style="color: #c71d1d;">
                                            {{formatIngredientDisplay(ingredient)}}<span *ngIf="!last">, </span>
                                        </span>
                                    </p>
                                </div>

                                <div class="half-half-section mt-1" *ngIf="isHalfAndHalf(customItem)">
                                    <div class="row">
                                        <div class="col-6">
                                            <p class="small text-muted mb-1">Left Half:</p>
                                            <p class="small text-muted mb-1" *ngFor="let ingredient of getLeftHalfIngredients(customItem)" style="color: #c71d1d;">
                                                {{formatIngredientDisplay(ingredient)}}
                                            </p>
                                        </div>
                                        <div class="col-6">
                                            <p class="small text-muted mb-1">Right Half:</p>
                                            <p class="small text-muted mb-1" *ngFor="let ingredient of getRightHalfIngredients(customItem)" style="color: #c71d1d;">
                                                {{formatIngredientDisplay(ingredient)}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="d-flex align-items-center" style="float: left;">
                                    <span class="text-muted">
                                        ${{getCustomProductPrice(customItem) | number:'1.2-2'}}
                                    </span>
                                    <span class="text-muted ms-2" style="font-size: 0.9em;">
                                        × {{customItem.quantity}} = ${{getCustomProductTotalPrice(customItem) | number:'1.2-2'}}
                                    </span>
                                </div>
                                <span class="text-muted float-end">QTY: {{customItem.quantity}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="account-card text-center" *ngIf="isLoading">
            <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div class="alert alert-danger text-center" *ngIf="(cartItemsLength === 0 && !isLoading) && (cartCustomProducts.length === 0 && !isLoading)">
            <div class="item-image">
                <img src="../../../../assets/img/home2/empty-cart.png" width="200" alt="Empty Cart">
            </div>
            
            <div class="item-details">
                <h3>Your cart is empty</h3>
                <p class="description">You haven't added any items to your cart yet.</p>
            </div>
        </div>
    </div>
    <!-- Left Column -->
    <div class="col-lg-12">
        <div class="row">
            <div class="" [ngClass]="guestMode || (deliveyOption == 'pickup') ? 'col-lg-12' : 'col-lg-6'">
                <div class="card mb-4">
                    <div class="card-body">
                        <h2 class="card-title mb-4">Personal Information </h2>
                        <form [formGroup]="informationDetailsForm" (ngSubmit)="saveAddress()">
                            <div class="row">
                                <div class="col-lg-12 mb-3">
                                    <label class="form-label">Full Name<span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" [readonly]="!guestMode" placeholder="Enter full name" name="fullname" formControlName="fullname">
                                    <div *ngIf="informationDetailsForm.get('fullname')?.invalid && informationDetailsForm.get('fullname')?.touched" 
                                        class="text-danger small mt-1">
                                        Full name is required
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-3">
                                    <label class="form-label">Phone Number<span class="text-danger">*</span></label>
                                    <input type="tel" class="form-control" [readonly]="!guestMode" placeholder="Enter phone number" [(ngModel)]="phoneNumber" name="phoneNumber" formControlName="phoneNumber"> <!--(input)="formatPhoneInput($event)"-->
                                    <div *ngIf="informationDetailsForm.get('phoneNumber')?.invalid && informationDetailsForm.get('phoneNumber')?.touched" 
                                        class="text-danger small mt-1">
                                        Valid phone number is required
                                    </div>
                                    <div *ngIf="informationDetailsForm.get('phoneNumber')?.pattern && informationDetailsForm.get('phoneNumber')?.touched" 
                                        class="text-danger small mt-1">
                                        Valid phone number is required
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-3">
                                    <label class="form-label">Email Address<span class="text-danger">*</span></label>
                                    <input type="email" class="form-control" [readonly]="!guestMode" placeholder="Enter email" name="email" formControlName="email">
                                    <div *ngIf="informationDetailsForm.get('email')?.invalid && informationDetailsForm.get('email')?.touched" 
                                        class="text-danger small mt-1">
                                        Valid email is required
                                    </div>
                                </div>
                                <div class="col-lg-12 mb-3">
                                    <label class="form-label">Note (Optional)</label>
                                    <textarea rows="5" class="form-control" [(ngModel)]="note" placeholder="Enter your notes" name="note" formControlName="note"></textarea>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-lg-12" >
                <div class="card oldAddress mb-4" *ngIf="deliveyOption != 'pickup'">
                    <div class="card-body">
                        <h2 class="card-title mb-4">Addresses</h2>
                        <!-- Loading State -->
                        <div class="account-card text-center" *ngIf="isLoading">
                            <div class="spinner-grow" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <!-- Addresses List -->
                        <div class="row" *ngIf="allAddresses && allAddresses.length > 0 && !guestMode">
                            <div class="col-lg-12 col-md-12 mb-4" *ngFor="let address of allAddresses">
                                <div class="card h-100" [class.border-primary]="address.isMain">
                                    <div class="card-body">
                                        <div class="d-flex justify-content-between align-items-start">
                                            <h5 class="card-title">{{address.city}}</h5>
                                            <span *ngIf="address.isMain" class="badge bg-primary">Main</span>
                                        </div>
                                        <p class="card-text">{{address.address}}</p>
                                    </div>
                                    <div class="card-footer bg-transparent">
                                        <!-- <button class="btn btn-sm btn-outline-primary me-2" (click)="editAddress(address)">
                                            <i class="bx bx-edit"></i> Edit
                                        </button> -->
                                        <button class="btn btn-sm btn-outline-danger me-2" (click)="deleteAddress(address.id)" 
                                                *ngIf="!address.isMain" [disabled]="isLoading">
                                            <i class="bx bx-trash"></i> Delete
                                        </button>
                                        <button class="btn btn-sm" 
                                                [class.btn-primary]="!address.isMain"
                                                [class.btn-success]="address.isMain"
                                                (click)="setAsMain(address.id)" 
                                                [disabled]="isLoading || address.isMain">
                                            <i class="bx" [class.bx-check]="address.isMain" [class.bx-star]="!address.isMain"></i>
                                            {{ address.isMain ? 'Main Address' : 'Set as Main' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-end">
                                <button class="btn btn-primary" id="AddNewAddress" (click)="addNewAddress()">
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                    Add New Address
                                </button>
                            </div>
                        </div>

                        <form class="d-none" id="addressForm" [formGroup]="addressForm" (ngSubmit)="submitAddress()">
                            <div class="row">
                            <!-- Country Dropdown -->
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Country <span class="text-danger">*</span></label>
                                    <select class="form-control w-100" formControlName="country_id" (change)="onCountryChange($event.target)">
                                        <option value="" disabled selected>Select Country</option>
                                        <option *ngFor="let country of allCountries" [value]="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <!-- {{ allCountries[0].name }} -->
                                    <div *ngIf="addressForm.get('country_id')?.hasError('required') && addressForm.get('country_id')?.touched" 
                                        class="text-danger small mt-1">
                                        Country is required
                                    </div>
                                </div>

                                <!-- City Dropdown -->
                                <div class="col-md-12 mb-3" >
                                    <label class="form-label">City <span class="text-danger">*</span></label>
                                    <select class="form-control w-100" formControlName="city_id">
                                        <option value="" disabled selected>Select City</option>
                                        <option *ngFor="let city of cities" [value]="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <div *ngIf="addressForm.get('city_id')?.hasError('required') && addressForm.get('city_id')?.touched" 
                                        class="text-danger small mt-1">
                                        City is required
                                    </div>
                                </div>

                                <!-- Address with Autocomplete -->
                                <div class="col-12 mb-3">
                                    <label class="form-label">Address <span class="text-danger">*</span></label>
                                    <input type="text" id="addressInput1" formControlName="address" 
                                        class="form-control" placeholder="Start typing your address...">
                                    <div *ngIf="addressForm.get('address')?.hasError('required') && addressForm.get('address')?.touched" 
                                        class="text-danger small mt-1">
                                    Address is required
                                    </div>
                                </div>

                                <!-- Building, Floor, Flat -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Building </label>
                                    <input type="text" class="form-control" formControlName="building" placeholder="Building no.">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Floor </label>
                                    <input type="text" class="form-control" formControlName="floor" placeholder="Floor no.">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Flat </label>
                                    <input type="text" class="form-control" formControlName="flat" placeholder="Flat no.">
                                </div>

                                <!-- Special Mark -->
                                <div class="col-12 mb-3">
                                    <label class="form-label">Special Mark </label>
                                    <textarea class="form-control" formControlName="special_mark" 
                                            placeholder="Any special landmarks or directions"></textarea>
                                </div>

                                <!-- Submit Button -->
                                <div class="col-12 text-center" *ngIf="!guestMode">
                                    <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                        Save Address
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

    <!-- Right Column -->
    <div class="col-lg-12">
      <!-- Order Summary -->
        <div class="card sticky-top" style="top: 20px; z-index: 1;">
            <div class="card-body px-5" style="background-color: #009246;border: 2px solid #000;border-radius: 8px;">
            <!-- <h2 class="card-title mb-4">Your Order</h2> -->
                <div class="mt-3 deliveryTipsContainer">
                    <p class="deliveryTipsTitle mb-3">Delivery Tips</p>
    
                    <div class="deliveryTipsOptions">
                        <!-- Percentage Options -->
                        <div class="delivery-tip-option" 
                            *ngFor="let percent of tipPercentages" 
                            [class.active]="selectedTip === percent"
                            (click)="selectTip(percent)">
                            <input class="d-none" type="radio" name="deliveryTip" 
                                    [id]="'tip-' + percent" [value]="percent" 
                                    [(ngModel)]="selectedTip">
                            <label [for]="'tip-' + percent">{{percent}}%</label>
                        </div>
                    </div>
    
                    <!-- Custom Amount Option -->
                    <div class="delivery-tip-option custom-option mt-2 mx-3" 
                        [class.active]="selectedTip === 'custom'"
                        (click)="selectCustomTip()">
                        <input class="d-none" type="radio" name="deliveryTip" 
                            id="tip-custom" value="custom" 
                            [(ngModel)]="selectedTip">
                        <label for="tip-custom">Other</label>
                        <input type="number" class="form-control custom-tip-input" 
                            *ngIf="selectedTip === 'custom'"
                            [(ngModel)]="customTipAmount" 
                            placeholder="Enter amount ($)"
                            (input)="calculateTotals()"
                            (click)="$event.stopPropagation()"
                            (focus)="selectCustomTip()"
                            min="0" step="0.01">
                    </div>
    
                    <!-- Reset Button -->
                    <div class="text-end mt-2">
                        <button class="btn btn-sm btn-outline-dark" (click)="resetTips(); calculateTotals()">
                            <i class="bx bx-undo me-1"></i> Reset
                        </button>
                    </div>
                </div>

                <!-- <div class="mt-3 deliveryMethodContainer">
                    <p class="deliveryMethodTitle mb-3">Delivery Method</p>

                    <div class="payment-option d-flex align-items-center">
                        <input type="radio" id="delivery" name="deliveryMethod" checked [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('delivery')" value="delivery">
                        <label style="font-size: 18px;" for="delivery">Delivery</label>
                    </div>
                    <div class="payment-option d-flex align-items-center">
                        <input type="radio" id="pickup" name="deliveryMethod" [(ngModel)]="deliveyOption" (click)="changeDeliveryMethod('pickup')" value="pickup">
                        <label style="font-size: 18px;" for="pickup">Pickup</label>
                    </div>
                    
                    <small *ngIf="deliveyOption == 'pickup'" class="text-success">Please notice your mailbox to get your order details</small>
                </div> -->

                <!-- <div class="mt-3 deliveryTipsContainer" *ngIf="selectedTip">
                    <p class="deliveryTipsTitle">Delivery Tips</p>
                    <div class="d-flex deliveryTipsNumbers">
                        <span class="deliveryTipsNumber">{{selectedTip}}%</span>
                    </div>
                </div> -->
            
                <div class="mt-4 pt-2" style="border-top: 1px solid #dee2e6;">
                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-white">Product total</span>
                        <span class="text-white">${{subtotalCart | number:'1.2-2'}}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-white">Service Fee</span>
                        <span class="text-white"><span *ngIf="feeType == 'fixed'">$</span> <span *ngIf="feeType == 'percentage'">%</span> {{feeValue | number:'1.2-2'}}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-white">Delivery fee</span>
                        <span class="text-white" *ngIf="delivery_fees == 0">Free</span>
                        <span class="text-white" *ngIf="delivery_fees > 0">${{delivery_fees | number:'1.2-2'}}</span>
                    </div>

                    <div class="d-flex justify-content-between mb-2">
                        <span class="text-white">Tax</span>
                        <span class="text-white"><span class="text-white" *ngIf="taxType == 'fixed'">$ {{taxValue}}</span> <span class="text-white" *ngIf="taxType == 'percentage'">$ {{(taxValue * (subtotalCart + feeValue)) / 100 | number:'1.2-2'}}</span></span>
                    </div>

                    <div class="d-flex justify-content-between mb-2" *ngIf="selectedTip">
                        <span class="text-white">Tips</span>
                        <span class="text-white" *ngIf="selectedTip != 'custom'">% {{selectedTip}} ($ {{tipAmount | number:'1.2-2'}}) </span>
                        <span class="text-white" *ngIf="customTipAmount && selectedTip == 'custom'">$ {{customTipAmount | number:'1.2-2'}}</span>
                    </div>
                    <div class="d-flex justify-content-between mb-2 text-success" *ngIf="discountFromOffers > 0">
                        <span class="text-white">Items Discount</span>
                        <span class="text-white">-${{discountFromOffers | number:'1.2-2'}}</span>
                    </div>

                    <div class="d-flex justify-content-between mb-2 text-success" *ngIf="couponApplied">
                        <span class="text-white" *ngIf="couponType == 'percentage'">Coupon: ({{couponValue}}%)</span>
                        <span class="text-white" *ngIf="couponType == 'value'">Coupon: ({{couponValue}}$ off)</span>
                        <span class="text-white">-${{discount | number:'1.2-2'}}</span>
                    </div>

                    <!-- <div class="d-flex justify-content-around mb-2 text-success" *ngIf="couponApplied">
                        <span *ngIf="couponType == 'percentage'">Coupon: ({{couponValue}}%)</span>
                        <span *ngIf="couponType == 'value'">Coupon: ({{couponValue}}$ off)</span>
                        <span>-${{discount | number:'1.2-2'}}</span>
                    </div> -->
                    
                    <div class="d-flex justify-content-around mt-3 py-2 border-top fw-bold fs-5" style="background: #fff;color: #003921;border-radius: 8px;">
                        <span>Total</span>
                        <span>${{totalCart | number:'1.2-2'}}</span>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-12 text-center">
        <button *ngIf="!isGuestMode" class="btn btn-primary w-auto mt-4 py-3 px-5 text-center" [disabled]="isLoadingPlaceOrder" (click)="placeOrder()"> <!--submitPayment()-->
            <span *ngIf="isLoadingPlaceOrder" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bx bxs-shopping-bag"></i>
            Place Order
        </button>

        <button *ngIf="isGuestMode" class="btn btn-primary w-auto mt-4 py-3 px-5 text-center" [disabled]="isLoadingPlaceOrder" (click)="placeOrderWithoutToken()"> <!--submitPaymentAsGuest()-->
            <span *ngIf="isLoadingPlaceOrder" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bx bxs-shopping-bag"></i>
            Place Order
        </button>
    </div>

  </div>
</div>

<app-footer-style-two></app-footer-style-two>